<template>
    <basic-modal @hide="close"
                 v-model="opened"
                 :aria-label="header"
                 role="dialog"
                 size="lg"
    >
        <div slot="header">
            <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
            <h3 class="modal-title">{{ header }}</h3>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="pillars-instructions">
                    {{ instructions }}
                </div>
                <div class="pillars-container">
                    <div class="pillars-scroll-area">
                        <div v-for="(pillar, pillarId) in goalPillars" :key="pillarId" class="checkbox pillar-item">
                            <label>
                                <input type="checkbox" v-model="selectedPillars[pillarId]">
                                <div class="pillar-details">
                                    <strong class="pillar-title">{{ pillar.title }}</strong>
                                    <div class="pillar-description">{{ pillar.description }}</div>
                                    <div class="pillar-subtitle">{{ pillar.subtitle }}</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer">
            <div class="row">
                <div class="col-xs-6 text-left">
                    <button class="btn btn-mm btn-default save-button" @click="close('back')">
                        <i class="far fa-chevron-left"></i> back
                    </button>
                </div>
                <div class="col-xs-6 text-right">
                    <button class="btn btn-mm btn-green save-button" @click="ok">
                        Next
                    </button>
                </div>
            </div>
        </div>
    </basic-modal>
</template>

<script>
    import PopupPromiseMixin from '~/vue/mixins/PopupPromiseMixin';
    import { goalPillars } from '../consts';

    export default {
        mixins: [PopupPromiseMixin],
        props: {
            initialSelectedPillars: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                instructions: 'Scroll down the list. Tick all the things this Goal has helped you — or the person you are supporting — with in life.',
                goalPillars,
                selectedPillars: {}
            };
        },
        computed: {
            header() {
                return `Finish ${this.$customTerm('Goal')}`;
            }
        },
        created() {
            // Initialize selectedPillars based on initialSelectedPillars prop
            if (this.initialSelectedPillars && this.initialSelectedPillars.length) {
                this.initialSelectedPillars.forEach(pillarId => {
                    if (this.goalPillars[pillarId]) {
                        this.$set(this.selectedPillars, pillarId, true);
                    }
                });
            }
        },
        methods: {
            ok() {
                // Return the IDs of selected pillars
                const selectedIds = Object.keys(this.selectedPillars)
                    .filter(pillarId => this.selectedPillars[pillarId])
                    .map(id => parseInt(id, 10));

                this.save(selectedIds);
            }
        }
    };
</script>

<style scoped lang="scss">
  @import "../../styles/const";

  .pillars-instructions {
    margin-bottom: 15px;
    font-weight: normal;
    font-size: $default-font-size;
  }

  .pillars-container {
    position: relative;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 20px;
  }

  .pillars-scroll-area {
    max-height: 300px;
    overflow-y: auto;
    padding: 10px 15px;
    font-size: $default-font-size;
  }

  .checkbox {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .checkbox label {
    font-weight: normal;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
  }

  .pillar-item {
    & + .pillar-item {
      margin-top: 15px;
      padding-top: 15px;
      border-top: 1px solid #eee;
    }
  }

  .pillar-details {
    margin-left: 10px;
  }

  .pillar-title {
    font-weight: bold;
  }

  .pillar-description {
    color: #333;
    margin-top: 4px;
  }

  .pillar-subtitle {
    color: #666;
    font-style: italic;
    margin-top: 4px;
  }

  .save-button {
    min-width: 100px;
  }
</style>
